import api from '../../../../../vue-woo/src/front/api'
import Cookie from './utilities/cookie'

// Detect obsolete browser and display alert
if (detectIE()) {
  alert(
    `Vous utilisez une version obsolète d'Internet Explorer. Afin de profiter au mieux de notre site nous vous invitons à utiliser Microsoft Edge, Firefox, Chrome ou d'autres navigateurs récents.`
  )
}

// Mobile menu
document.querySelector('.hamburger').addEventListener('click', function () {
  const navPrimary = document.querySelector('.nav-primary')
  const siteInner = document.querySelector('.site-inner')
  this.classList.toggle('is-active')
  navPrimary.classList.toggle('is-active')
  if (navPrimary.classList.contains('is-active')) {
    siteInner.style.transform = `translateY(${navPrimary.clientHeight}px)`
  } else {
    setTimeout(() => (siteInner.style.transform = `translateY(0)`), 150)
  }
})
document.querySelectorAll(`.menu-item-has-children > a`).forEach((link) => {
  link.addEventListener('click', function (event) {
    if (window.innerWidth <= 960) {
      event.preventDefault()
      this.parentNode.classList.toggle(`mobile-display-sub`)
    }
  })
})

let fetched = false

// Search bar
function searchBar() {
  const trigger = document.querySelectorAll('.js-search-bar') // both mobile and desktop
  const searchModal = document.getElementById('js-modal-search')
  trigger.forEach((t) =>
    t.addEventListener('click', (event) => {
      event.preventDefault()
      searchModal.showModal()
      if (!fetched) {
        getDatalists()
      }
    })
  )

  searchModal.addEventListener("click", e => {
    const dialogDimensions = searchModal.getBoundingClientRect()
    if (
      e.clientX < dialogDimensions.left ||
      e.clientX > dialogDimensions.right ||
      e.clientY < dialogDimensions.top ||
      e.clientY > dialogDimensions.bottom
    ) {
      searchModal.close()
    }
  })

  const urlParams = new URLSearchParams(window.location.search)

  if (urlParams.has('s')) {
    getDatalists()
    // searchBar.fadeIn();
  }

  // save parrainage # in localStorage if user comes from email link
  if (urlParams.has('parrainage_id')) {
    api.get(`g2r/v1/referrals/${urlParams.get('parrainage_id')}`)
      .then((data) => {
        if (data.used_in) {
          alert(`Cette offre de parrainage a déjà été utilisée.`)
        } else {
          // eslint-disable-next-line no-undef
          Cookies.set(
            'parrainage_id',
            urlParams.get('parrainage_id'),
            {expires: 365}
          )
        }
      })
      .catch((error) => console.error(error))
  }
}

function getDatalists() {
  api.get(`g2r/v1/search/datalists`)
    .then((response) => response.data)
    .then((data) => {
      go2rouesCustomSearch(data)
      fetched = true
    })
    .catch((error) => console.error(error))
}

searchBar()

// Search form
function go2rouesCustomSearch(data) {
  const datalists = document.querySelectorAll('datalist')
  datalists.forEach(datalist => {
    const optionsArray = data[datalist.id]
    optionsArray.forEach(obj => {
      const el = document.createElement('option')
      el.setAttribute('value', obj.name)
      el.setAttribute('data-url', obj.link)
      datalist.appendChild(el)
    })
  })
  const mapping = {
    vehicules: {
      placeholder: 'Recherche de véhicules...',
      list: 'products-list',
      postType: 'product',
    },
    accessoires: {
      placeholder: "Recherche d'accessoires...",
      list: 'accessoires-list',
      postType: 'product',
    },
    articles: {
      placeholder: "Recherche d'articles...",
      list: 'posts-list',
      postType: 'post',
    },
    occasions: {
      placeholder: "Recherche d'occasions...",
      list: 'occasions-list',
      postType: 'product',
    },
  }
  // Switch for search_in
  const searchForm = new Map()
  document
    .querySelectorAll('.woocommerce-product-search [name]')
    .forEach((input) => searchForm.set(input.getAttribute('name'), input))
  searchForm.get('search_in').addEventListener('change', function () {
    Object.keys(mapping).forEach((key) => {
      if (this.value === key) {
        searchForm.get('s').placeholder = mapping[key].placeholder
        searchForm.get('s').setAttribute('list', mapping[key].list)
        searchForm.get('post_type').value = mapping[key].postType
      }
    })
  })
  // Redirect to product url when selected in datalist
  const datalistArray = ['products', 'accessoires', 'posts', 'occasions']
  let datalistMapping = []
  datalistArray.forEach((dl) =>
    datalistMapping.push({
      list: document.querySelectorAll(`#${dl}-list option`),
      map: new Map(),
    })
  )
  datalistMapping.forEach((obj) => {
    obj.list.forEach((option) =>
      obj.map.set(option.value, option.getAttribute('data-url'))
    )
  })
  searchForm.get('s').addEventListener('change', function () {
    datalistMapping.forEach((obj) => {
      if (obj.map.has(this.value)) {
        window.location.href = obj.map.get(this.value)
      }
    })
  })
}

document.addEventListener(`DOMContentLoaded`, () => {
  // Remove auto_login cookie after redirect
  if ('1' === Cookie.getCookie('template_redirect')) {
    Cookie.deleteCookie('auto_login')
  }
})

// Populates comparateur-count if needed
const comparateurButton = document.querySelector(
  `.header__widget-area--icons .comparateur-icon`
)
const comparateurCount = document.querySelector(`svg.comparateur-count`)
const comparateurCountText = comparateurCount.querySelector(`text`)
if (null !== localStorage.getItem('comparateur')) {
  let count = JSON.parse(localStorage.getItem('comparateur')).length
  if (count > 0) {
    comparateurCountText.innerHTML = count
    comparateurCount.style.opacity = 1
  }
}

comparateurButton.addEventListener('click', function (event) {
  event.preventDefault()
  // eslint-disable-next-line no-undef
  window.g2rDisplayPreview()
})

// Exposes variables
window.comparateurCountText = comparateurCountText
window.comparateurCount = comparateurCount
window.$api = api
window.$cookie = Cookie

// export default comparateurCount

/**
 * detect IE     // https://codepen.io/gapcode/pen/vEJNZN
 * returns version of IE or false, if browser is not Internet Explorer
 */
function detectIE() {
  let ua = window.navigator.userAgent

  // Test values; Uncomment to check result …

  // IE 10
  // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

  // IE 11
  // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

  // Edge 12 (Spartan)
  // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

  // Edge 13
  // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

  let msie = ua.indexOf('MSIE ')
  if (msie > 0) {
    // IE 10 or older => return version number
    // return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    return true
  }

  let trident = ua.indexOf('Trident/')
  if (trident > 0) {
    // IE 11 => return version number
    // let rv = ua.indexOf('rv:');
    // return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    return true
  }

  // var edge = ua.indexOf('Edge/');
  // if (edge > 0) {
  //     // Edge (IE 12+) => return version number
  //     return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  // }

  // other browser
  return false
}

// Exposes scrollY globally
let lastKnownScrollPosition = 0
let ticking = false
window.addEventListener('scroll', function () {
  lastKnownScrollPosition = window.scrollY
  const event = new CustomEvent('g2rScroll', {
    detail: lastKnownScrollPosition,
  })

  if (!ticking) {
    window.requestAnimationFrame(function () {
      document.dispatchEvent(event)
      ticking = false
    })

    ticking = true
  }
})

// Lazy load footer bacjground image
let bgFooter = document.querySelector('.building_bg_footer');
let footerBgInjected = false;
let footerCallback = function(entries) {
  entries.forEach(entry => {
    if (entry.isIntersecting && !footerBgInjected) {
      bgFooter.style.backgroundImage = `url('/wp-content/themes/genesis-go2roues/svg/building_bg_footer.svg')`;
    }
  });
};
window.addEventListener('load', () => {
  let observer = new IntersectionObserver(footerCallback, {rootMargin: "0px 0px 200px 0px"})
  observer.observe(bgFooter)
})
